import React, { useMemo } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';
import envs from '../config/envs';
import TokenManager from '../core/auth/TokenManager';

const ApolloProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const client = useMemo(() => {
    const uploadLink = createUploadLink({
      uri: envs.graphqlEndpoint,
    });

    const authLink = setContext((_, { headers }) => {
      const token = TokenManager.getToken();
      const normalizedToken = token?.startsWith('Bearer ') ? token.slice(7).trim() : token;
      return {
        headers: {
          ...headers,
          authorization: normalizedToken ? `Bearer ${normalizedToken}` : '',
        },
      };
    });

    const errorLink = onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );
      }
      if (networkError) {
        console.error(`[Network error]: ${networkError}`);
      }
    });

    return new ApolloClient({
      link: ApolloLink.from([errorLink, authLink, uploadLink as unknown as ApolloLink]),
      cache: new InMemoryCache(),
    });
  }, []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloProviderWrapper;
